/**
 * 検索結果のピンを地図の中央に保つための、ポップアップ最大高さを算出するユーティリティ。
 *
 * Leaflet のポップアップは autoPan（既定 ON）が働き、開いたポップアップが地図からはみ出す場合は
 * 収まるように地図側をずらす。住所・地番検索でピンを中央へ移動した直後にポップアップを開くと、
 * この autoPan によって地図が下方向へパンし、検索した地点が中央からずれてしまう。
 *
 * ポップアップの高さを「中央のピンの上にちょうど収まる高さ」までに制限すれば autoPan は発生せず、
 * 検索地点が中央に留まる。収まらない内容はポップアップ内スクロール（leaflet-popup-scrolled）になる。
 *
 * 高さの内訳（Leaflet 1.9 + 既定マーカーアイコン）:
 * - popupAnchor: 34px（ピン先端からポップアップ下端までの距離）
 * - autoPanPadding: 5px（autoPan が許容する地図端との余白）
 * - ポップアップ自体の余白: コンテンツラッパーの padding 28px + 吹き出し部分の marginBottom 20px
 */
const POPUP_ANCHOR_OFFSET_PX = 34;
const AUTO_PAN_PADDING_PX = 5;
const POPUP_CHROME_HEIGHT_PX = 28 + 20;

/** 地図が極端に低い場合でも最低限の表示領域を確保するための下限値 */
export const POPUP_MIN_MAX_HEIGHT_PX = 160;

/**
 * autoPan による中心ズレを起こさないポップアップの最大高さ（px）を返す
 * @param mapHeightPx 地図コンテナの高さ(px)
 */
export const calcPopupMaxHeight = (mapHeightPx: number): number =>
  Math.max(
    POPUP_MIN_MAX_HEIGHT_PX,
    Math.floor(mapHeightPx / 2) -
      POPUP_ANCHOR_OFFSET_PX -
      AUTO_PAN_PADDING_PX -
      POPUP_CHROME_HEIGHT_PX
  );
